module.exports = __webpack_public_path__ + "assets/fonts/Gotham-BlackItalic.fb06511a.otf";